// extracted by mini-css-extract-plugin
module.exports = {"loader":"Title_loader__TsIg2","placeholder":"Title_placeholder__6cwEC"};